import { createFormItem, evaluateCondition, evaluateConditionGroup } from '../../../configuration/formItemFactory'
import _ from 'lodash'
import { mockFormData } from './mock'


export const resetData = (params) => {
  const nodeData = {};
  params.forEach((item, index) => {
    const { type, payload } = item;
    const field = payload.field;
    const visibility_conditions = payload.visibility_conditions || [];
    const formItem = createFormItem(type, payload, (current, acients, formData) => {
      if (!visibility_conditions.length) {
        const data = params[index + 1];
        if (!data) {
          return null
        } else {
          const { field } = data.payload;
          return nodeData[field]
        }
      }
      const result = visibility_conditions.find(condition => {
        // const { operator, conditions } =condition
        return evaluateConditionGroup(condition, formData)
      });

      if (result) {
        return nodeData[result.effects]
      } else {
        return null
      }
      // 处理表单数据的逻辑
      console.log('Form data:', current);
      // 可以在这里执行其他操作，比如发送请求、更新状态等
    });
    nodeData[field] = formItem;
  });
  const { payload } = _.head(mockFormData);
  return nodeData[payload.field] 
}

// export default nodeData[payload.field] 
